export default __webpack_public_path__ + "static/media/endemic-tile.85a7288c.svg";